import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useLocation } from 'react-router';
import {
  Box,
  Link,
  Typography,
  makeStyles
} from '@material-ui/core';
import queryString from 'query-string';
import SignInForm from './SignInForm';
import BaseAuthPage from '../BaseAuthPage';
import BaseCard from '../BaseCard';

const useStyles = makeStyles(() => ({
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
  }
}));

function SignIn() {
  const classes = useStyles();
  const location = useLocation();
  const { info } = queryString.parse(location.search);

  const footer = (
    <Box className={classes.footer}>
      <Link
        component={RouterLink}
        to="/forgot-password"
        variant="body2"
        color="textSecondary"
      >
        Forgot your password?
      </Link>
      <Typography variant="body2">
        Dont have an account?&nbsp;
        <Link
          component={RouterLink}
          to="/register"
          variant="body2"
          color="textSecondary"
        >
          Sign up
        </Link>
      </Typography>
    </Box>
  );

  return (
    <BaseAuthPage title="Sign in">
      <BaseCard
        title="Sign in"
        subtitle="Sign in to flexbase"
        footer={footer}
      >
        <SignInForm isVerified={info === 'verified'} />
      </BaseCard>
    </BaseAuthPage>
  );
}

SignIn.propTypes = {
  isVerified: PropTypes.bool,
};

export default SignIn;
